"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkNavigator = exports.LinkNavigationHandler = void 0;
/**
 * Copyright 2021 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const mfe_framework_1 = require("../framework/mfe-framework");
class LinkNavigationHandler {
    constructor() {
        this.defaultNavigationHandler = (event) => {
            var _a, _b;
            const url = ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.href) || ((_b = event.detail) === null || _b === void 0 ? void 0 : _b.url);
            if (url) {
                window.location.href = url;
            }
        };
        this.registeredNavigationSource = LinkNavigationHandler.IMPLICIT_NAVIGATION_HANDLER_SOURCE;
        this.registeredNavigationHandler = this.defaultNavigationHandler;
    }
    static getInstance() {
        if (!LinkNavigationHandler.instance) {
            LinkNavigationHandler.instance = new LinkNavigationHandler();
        }
        return LinkNavigationHandler.instance;
    }
    registerNavigationHandler(source, navigationHandler) {
        if (!navigationHandler) {
            this.registeredNavigationSource = LinkNavigationHandler.IMPLICIT_NAVIGATION_HANDLER_SOURCE;
            this.registeredNavigationHandler = this.defaultNavigationHandler;
        }
        this.registeredNavigationSource = source;
        this.registeredNavigationHandler = navigationHandler;
    }
    triggerNavigation(event) {
        this.registeredNavigationHandler(event);
    }
    isSingleSpaRoute(route) {
        if (!route) {
            return false;
        }
        const origin = window.location.origin;
        if (!route.startsWith(origin)) {
            return false;
        }
        const relativeRoute = new URL(route).pathname || '';
        const relativeRouteSegments = this.getRouteSegments(relativeRoute);
        const matches = mfe_framework_1.MfeFramework.registeredApplications
            .filter(registeredApplication => this.startsWithSegments(this.getRouteSegments(registeredApplication.route), relativeRouteSegments));
        return (matches.length > 0);
    }
    getRouteSegments(route) {
        return (route || '').split('/').filter(s => !!s).map(s => s.toLowerCase());
    }
    startsWithSegments(target, startsWith) {
        if (target.length > startsWith.length) {
            return false;
        }
        for (let i = 0; i < Math.min(target.length, startsWith.length); i++) {
            if (target[i] !== startsWith[i]) {
                return false;
            }
        }
        return true;
    }
}
exports.LinkNavigationHandler = LinkNavigationHandler;
LinkNavigationHandler.IMPLICIT_NAVIGATION_HANDLER_SOURCE = 'Implicit LinkNavigationHandler';
exports.LinkNavigator = LinkNavigationHandler.getInstance();
//# sourceMappingURL=link-navigation-handler.js.map